import gsap from 'gsap';
import ready, { HTML } from 'Utils';
import initMobileMenu from 'Components/mobileMenu';
import initToggleTabs from 'Components/toggleTabs';
import initOpenClose from 'Components/openClose';
import initPromoPanel from 'Components/promoPanel';
import initModal from 'Components/modal';
import initAccordion from './components/accordion';
import initTabs from './components/tabs';
import initSearchHeader from './components/searchHeader';
import initSearchClear from './components/searchClear';
import initStatsAnimation from './components/statsAnimation';
import initQuoteAnimate from './components/quoteAnimate';
import initSwiper from './components/swiper';
import initResourceFilter from './components/resourceFilter';
import initResourceCarousel from './components/resourceCarousel';
import initJumpNav from './components/jumpNav';
import initDuetDatePicker from './components/duetDatePicker';

gsap.defaults({ ease: 'power2.inOut', duration: 0.3 });

ready(() => {
  HTML.classList.add('is-loaded');
  initMobileMenu();
  initPromoPanel();
  initToggleTabs();
  initOpenClose();
  initModal();
  initAccordion();
  initTabs();
  initSearchHeader();
  initSearchClear();
  initStatsAnimation();
  initQuoteAnimate();
  initSwiper();
  initResourceFilter();
  initResourceCarousel();
  initJumpNav();
  initDuetDatePicker();
});
